
import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import "../CustomInputLogin/CustomInputLogin.css";
import "../ComponentsCss/componet.css";
import { Field, ErrorMessage, useFormikContext } from "formik";
import { InputAdornment, Typography, IconButton, Box } from "@mui/material";
import { FaStarOfLife } from "react-icons/fa6";
import { useField } from "formik";
import EmojiPicker from "emoji-picker-react";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";

const CustomInputWithMessageEmoji = ({
  label,
  name,
  custPlaceholder,
  image,
  important,
  inputType,
  ...rest
}) => {
  const [field, meta] = useField(name);
  const { setFieldValue } = useFormikContext();
  const [showPicker, setShowPicker] = useState(false);
  const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });

  const inputRef = useRef();
  const pickerRef = useRef();
  const emojiBtnRef = useRef();

  const handleEmojiClick = (emojiObject) => {
    setFieldValue(name, (field.value || "") + emojiObject.emoji);
  };

  const toggleEmojiPicker = () => {
    if (inputRef.current) {
      const rect = inputRef.current.getBoundingClientRect();
      setPickerPosition({
        top: rect.bottom + window.scrollY,
        // top: 40,

        left: rect.left + window.scrollX,
      });
    }
    setShowPicker((prev) => !prev);
  };

  // 👉 Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        pickerRef.current &&
        !pickerRef.current.contains(event.target) &&
        !emojiBtnRef.current.contains(event.target)
      ) {
        setShowPicker(false);
      }
    };

    if (showPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPicker]);

  return (
    <div style={{ width: "100%", position: "relative" }}>
      <div>
        <Typography variant="body1">
          <label
            htmlFor={name}
            className="input-heading12"
            style={{
              fontSize: "15px",
              fontWeight: "450",
              color: "black",
            }}
          >
            {label}
          </label>
          {important && (
            <FaStarOfLife
              style={{ color: "#F53E5C", fontSize: "8px", marginLeft: "3px" }}
            />
          )}
        </Typography>
      </div>

      <div style={{ position: "relative", width: "100%" }}>
        {image && (
          <InputAdornment
            position="start"
            style={{
              position: "absolute",
              top: "50%",
              left: "8px",
              transform: "translateY(-50%)",
            }}
          >
            <img src={image} style={{ height: "17px" }} alt="icon" />
          </InputAdornment>
        )}

        <Field
          id={name}
          name={name}
          as={inputType === "textarea" ? "textarea" : "input"}
          type={inputType !== "textarea" ? inputType : "text"}
          placeholder={custPlaceholder || "Enter Input"}
          {...field}
          {...rest}
          style={{
            width: "100%",
            borderRadius: "3px",
            boxSizing: "border-box",
            height: inputType === "textarea" ? "100px" : "45px",
            paddingLeft: "40px",
          }}
          className="custominput-field12"
          innerRef={inputRef}
          ref={inputRef}
        />

        {/* Emoji Button */}
        <IconButton
          onClick={toggleEmojiPicker}
          ref={emojiBtnRef}
          style={{
            position: "absolute",
            left: "5px",
            top: inputType === "textarea" ? "10px" : "5px",
          }}
        >
          <EmojiEmotionsIcon fontSize="small" />
        </IconButton>
      </div>

      {/* Emoji Picker rendered in portal */}
      {showPicker &&
        ReactDOM.createPortal(
          <Box
            ref={pickerRef}
            sx={{
              position: "absolute",
              top: { xs: pickerPosition.top, md:40},
              // top: pickerPosition.top,

              // bottom: pickerPosition.bottom,
              left: pickerPosition.left,
              zIndex: 9999,
              width: {xs:"300px",md:"360px"},
              overflowX: {xs:"scroll",md:"hidden"}
            }}
          >
            <EmojiPicker onEmojiClick={handleEmojiClick} />
          </Box>,
          document.body
        )}

      <ErrorMessage
        name={name}
        component="div"
        className="inputs-error-msg"
        style={{ color: "red", fontSize: "12px", fontWeight: "400" }}
      />
    </div>
  );
};

export default CustomInputWithMessageEmoji;
